"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryListRequestSource = void 0;
exports.HistoryListRequestSource = {
    Tts: "TTS",
    Sts: "STS",
};
